<template>
  <form>
    <slot></slot>
  </form>
</template>

<script>
    import Emitter from "@/utils/emitter";

export default {
  mixins: [Emitter],

  props: {
    model: {},
    rules: {},
  },
  provide(){
    return {
        byForm:this
    }
  },
  data(){
      return {
        ruleKeys:[]
      }
  },
  mounted(){
     this.ruleKeys= Object.keys(this.rules)

  },
  methods: {
    validate(cb) {
       
      // Object.keys(rules).forEach((vk,index)=>{
      //     if(this.model[vk].length===0){

      //     }

      // })
      for (const vk of this.ruleKeys) {
        //   debugger
        if (!this.model[vk]||this.model[vk].length===0 ) {
            this.broadcast('ByFormItem','by.form.submit',vk)
          return cb(vk);
        }
      }
      return cb(true);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/reception/checkPrice/components/ByForm.vue